import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

import FastField from '../../commons/FastField';
import AntSelect from '../../commons/AntSelect';
import AntAutoComplete from '../../commons/AntAutoComplete';
import AntDatePicker from '../../commons/AntDatePicker';
import AntInput from '../../commons/AntInput';
import AntTextArea from '../../commons/AntTextArea';
import Info from '../../commons/Info';

import info from './info';

const IncedentForm = ({
  fields,
  directions,
  eventTypes,
  classTags,
  techTags,
  typeTags,
  platform,
  game,
  versions,
}) => {
  const getFieldProps = name => {
    const disabled = !fields.filter(item => item === name).length;
    return { name, disabled, 'data-test': name };
  };

  const renderAppVersionRange = () => (
    <Row gutter={4}>
      <Col span={12}>
        <FastField
          {...getFieldProps('minAppVersion')}
          label="Min App Version"
          placeholder="example 0.1.0"
          component={AntAutoComplete}
          options={versions}
        />
      </Col>
      <Col span={12}>
        <Info text={info.maxAppVersion}>
          <FastField
            {...getFieldProps('maxAppVersion')}
            label="Max App Version"
            placeholder="example 0.1.0"
            component={AntAutoComplete}
            options={versions}
          />
        </Info>
      </Col>
    </Row>
  );

  const renderRequired = () => (
    <>
      <Row gutter={16}>
        <Col span={6}>
          <FastField
            {...getFieldProps('direction')}
            label="Direction"
            placeholder="click and select..."
            component={AntSelect}
            options={directions}
          />
        </Col>
        <Col span={6}>
          <FastField
            {...getFieldProps('eventType')}
            label="Event type"
            placeholder="click and select..."
            component={AntSelect}
            options={eventTypes}
          />
        </Col>

        <Col offset={4} span={8}>
          <Info text={info.dateTime}>
            <FastField
              {...getFieldProps('dateTime')}
              label="Event Date & Time"
              placeholder="click and select..."
              component={AntDatePicker}
            />
          </Info>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={6}>
          <FastField
            {...getFieldProps('game')}
            label="Games"
            placeholder="click and select..."
            component={AntSelect}
            options={game}
            // mode="multiple"
          />
        </Col>
        <Col span={6}>
          <FastField
            {...getFieldProps('platform')}
            label="Platforms"
            placeholder="click and select..."
            component={AntSelect}
            options={platform}
            mode="multiple"
          />
        </Col>
        <Col span={12}>
          <Info text={info.link}>
            <FastField
              {...getFieldProps('notesLink')}
              label="Notes Link"
              placeholder="start typing..."
              component={AntInput}
            />
          </Info>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <FastField
            {...getFieldProps('description')}
            label="Description"
            placeholder="start typing..."
            component={AntTextArea}
            style={{ height: 120 }}
          />
        </Col>
      </Row>
    </>
  );

  const renderAdditional = () => {
    return (
      <div
        style={{ borderLeft: '1px solid rgba(0, 0, 0, 0.25)', paddingLeft: 15 }}
      >
        <Row gutter={16} style={{ marginTop: -20 }}>
          <Col
            span={24}
            style={{
              fontSize: 10,
              color: 'rgb(24, 144, 255)',
              paddingBottom: 5,
            }}
          >
            Additional Fields
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Info text={info.resolutionDate}>
              <FastField
                {...getFieldProps('resolutionDate')}
                label="Resolution Date & Time"
                placeholder="click and select..."
                component={AntDatePicker}
              />
            </Info>
          </Col>
        </Row>
        {renderAppVersionRange()}
        <Row>
          <Col span={24}>
            <Info text={info.techTag}>
              <FastField
                {...getFieldProps('techTag')}
                label="Tech Tag"
                placeholder="click and select..."
                component={AntSelect}
                options={techTags}
              />
            </Info>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Info text={info.classTag}>
              <FastField
                {...getFieldProps('classTag')}
                label="Class Tag"
                placeholder="click and select..."
                component={AntSelect}
                options={classTags}
              />
            </Info>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Info text={info.typeTag}>
              <FastField
                {...getFieldProps('typeTag')}
                label="Type Tag"
                component={AntAutoComplete}
                options={typeTags}
                placeholder="start typing..."
              />
            </Info>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <Row gutter={30}>
      <Col span={18}>{renderRequired()}</Col>
      <Col span={6}>{renderAdditional()}</Col>
    </Row>
  );
};

IncedentForm.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
  directions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  eventTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  classTags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  platform: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  game: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  typeTags: PropTypes.arrayOf(PropTypes.string).isRequired,
  techTags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  displayConfig: PropTypes.shape({
    isMaxVersion: PropTypes.bool,
    isServerVersion: PropTypes.bool,
    isСhannel: PropTypes.bool,
    isAudience: PropTypes.bool,
  }).isRequired,
  versions: PropTypes.arrayOf(PropTypes.string).isRequired,
  info: PropTypes.shape({
    responsible: PropTypes.string,
    eventType: PropTypes.string,
    dateTime: PropTypes.string,
    appVersion: PropTypes.string,
    maxAppVersion: PropTypes.string,
    link: PropTypes.string,
    audience: PropTypes.string,
  }).isRequired,
};

export default IncedentForm;
